// src/components/ProfileInfoCard.jsx
import React from 'react';
export default function ProfileInfoCard({ job, engraving, level, power }) {
  const parseBadge = (value) => {
    const str = String(value ?? '').trim();
    const m = str.match(/\((↑|↓)\s*([^)]+)\)\s*$/);
    if (!m) return { base: str, badge: null, dir: null };
    // ↙️ 불필요 이스케이프 제거 (\- → -)
    const num = parseFloat(m[2].replace(/[^0-9.-]/g, ''));
    if (isNaN(num) || num === 0) {
      // 변동값이 없으면 표시 안 함
      return { base: str.replace(/\s*\((↑|↓)[^)]+\)\s*$/, '').trim(), badge: null, dir: null };
    }
    const dir = m[1] === '↑' ? 'up' : 'down';
    const base = str.replace(/\s*\((↑|↓)[^)]+\)\s*$/, '').trim();
    const badge = `${m[1]}${m[2]}`.replace(/\s+/g, '');
    return { base, badge, dir };
  };
  const badgeClass = (dir) =>
    dir === 'up'
      ? 'inline-flex items-center gap-x-1.5 rounded-md px-1.5 py-0.5 text-xs font-medium bg-red-500/15 text-red-700 dark:bg-red-400/10 dark:text-red-400'
      : 'inline-flex items-center gap-x-1.5 rounded-md px-1.5 py-0.5 text-xs font-medium bg-emerald-500/15 text-emerald-700 dark:bg-emerald-400/10 dark:text-emerald-300';
  const { base: levelBase, badge: levelBadge, dir: levelDir } = parseBadge(level);
  const { base: powerBase, badge: powerBadge, dir: powerDir } = parseBadge(power);
  return (
    <section className="flex flex-col lg:flex-row basis-1/2 gap-2 lg:gap-6 rounded-lg border border-zinc-950/10 bg-white px-4 py-3 shadow-sm dark:border-white/10 dark:bg-zinc-900 dark:shadow-none">
      <div className="flex flex-col">
        <span className="text-sm text-zinc-500 dark:text-zinc-400">직업</span>
        <span className="font-medium text-zinc-950 dark:text-white">
          {job}
          {engraving && (
            <span className="ml-1 align-middle rounded bg-indigo-500/10 px-1.5 py-0.5 text-xs font-medium text-indigo-700 dark:bg-indigo-400/20 dark:text-indigo-300">
              {engraving}
            </span>
          )}
        </span>
      </div>
      <div className="flex flex-col">
        <span className="text-sm text-zinc-500 dark:text-zinc-400">레벨</span>
        <span className="font-medium text-zinc-950 dark:text-white">
          {levelBase}
          {levelBadge && (
            <span className={`ml-2 ${badgeClass(levelDir)}`}>{levelBadge}</span>
          )}
        </span>
      </div>
      <div className="flex flex-col">
        <span className="text-sm text-zinc-500 dark:text-zinc-400">전투력</span>
        <span className="font-medium text-zinc-950 dark:text-white">
          {powerBase}
          {powerBadge && (
            <span className={`ml-2 ${badgeClass(powerDir)}`}>{powerBadge}</span>
          )}
        </span>
      </div>
    </section>
  );
}
